import { type Prize } from '@/entities/wheel/model/wheel.types';

import { type Game } from '@/shared/store/games-store/types';
import { type Currency } from '@/shared/types/common';

export interface MarketAdsActions {
  hydrate: (fresh: Partial<MarketState>) => void;
  fetchProducts: () => Promise<
    Partial<Pick<MarketState, 'main' | 'partner'>> | undefined
  >;
  checkNewProducts: (tab: ShopTab) => Promise<never[] | undefined>;
}

export enum MarketItemType {
  TICKET = 'TICKET',
  PREMIUM = 'PREMIUM',
  BOOSTER_PLAYCOIN = 'BOOSTER_PLAYCOIN',
  BOOSTER_XP = 'BOOSTER_XP',
  PLAYCOIN = 'PLAYCOIN',
  LEAGUE_UP = 'LEAGUE_UP',
  PARTNER = 'PARTNER',
  CLICKER_XP = 'CLICKER_XP',
  CLICKER_PLAYCOIN = 'CLICKER_PLAYCOIN',
  ULTRA_LVL = 'ULTRA_LVL',
  BOINKERS_BOOSTER = 'BOINKERS_BOOSTER',
  EXTERNAL = 'EXTERNAL',
  FEATURE_SPIN_X = 'FEATURE_SPIN_X',
  LOOTBOX = 'LOOTBOX',
  CONFETTI = 'CONFETTI',
  BOOSTER_LB_SCORE = 'BOOSTER_LB_SCORE',
}

export interface ShopItemPrice {
  currency: Currency;
  value: number;
  valueWithDiscount: number | null;
}

export interface MarketItem {
  id: number;
  // eslint-disable-next-line @typescript-eslint/ban-types
  type: MarketItemType | (string & {});
  name: string;
  amount: number;
  specialOffer: boolean;
  icon?: string | null;
  partner?: string | null;
  price: ShopItemPrice;
  duration?: number | null;
  offerEndsAt?: number | null;
  ad?: string | null;
  description?: string | null;
  activationLink?: string | null;
  blockingNextTill: number | null;
  isSubscription?: boolean | null;
  subscriptionDetails?: { status: SubscriptionStatus; expireAt?: number } | null;
  xpReward?: number | null;
  oneTimeOffer: boolean;
  wasPurchased: boolean;
  externalUrl: string | null;
  best?: boolean;
  popular?: boolean;
  game?: Game;
  promoCode?: string;
}

export enum SubscriptionStatus {
  NotSubscribed = 0,
  InProcess = 1,
  Subscribed = 2,
  UnsubscribedButActive = 3,
}

export interface MarketCategory {
  key: string;
  content: MarketItem[];
}

export interface Purchase {
  id: number;
  // eslint-disable-next-line @typescript-eslint/ban-types
  type: MarketItemType | (string & {});
  price: number;
  currency: Currency;

  isSubscription: boolean;
}

export interface PurchasedItem {
  url: string;
  item: Prize | null | undefined;
}

export interface MarketState {
  main: MarketItem[] | undefined;
  partner: MarketItem[] | undefined;
  hasNewPartnerProducts: boolean;
  hasNewInnerProducts: boolean;
  actions: MarketAdsActions;
}

export enum ShopTab {
  FOR_YOU = 'FOR_YOU',
  PARTNER_DEALS = 'PARTNER_DEALS',

  // TODO: Don't do this yet
  // FOR_FRIENDS = 'FOR_FRIENDS',
}
